import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TrackerService } from 'src/app/shared/util/tracker.service';
import { environment } from 'src/environments/environment';
import {
  ProductDetailSection,
  ProductFeature,
  buildDetailSectionKeys,
  getAdjacentFeatures,
  getProductFeature,
} from '../products.data';
import { ProductScreenshotSlide } from '../product-screenshot/product-screenshot.component';

export interface ResolvedDetailSection extends ProductDetailSection {
  titleKey: string;
  introKey: string;
  items: { titleKey: string; textKey: string }[];
}

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
})
export class ProductDetailComponent implements OnInit {
  feature: ProductFeature | null = null;
  detailSections: ResolvedDetailSection[] = [];
  prevFeature: ProductFeature | undefined;
  nextFeature: ProductFeature | undefined;
  assistantHref = '';
  assistantLoginHref = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public translate: TranslateService,
    private trackerService: TrackerService
  ) {}

  ngOnInit(): void {
    this.trackerService.trackPageViews();
    this.assistantHref = environment.assistantApp;
    this.assistantLoginHref = `${environment.assistantApp}/login`;

    this.route.paramMap.subscribe((params) => {
      const id = params.get('featureId') || '';
      const found = getProductFeature(id);
      if (!found) {
        this.router.navigate(['/products']);
        return;
      }
      this.feature = found;
      this.detailSections = found.detailSections.map((section) => ({
        ...section,
        ...buildDetailSectionKeys(found.id, section),
      }));
      const adjacent = getAdjacentFeatures(id);
      this.prevFeature = adjacent.prev;
      this.nextFeature = adjacent.next;
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
  }

  trackBySectionIndex(index: number): number {
    return index;
  }

  trackByItemIndex(index: number): number {
    return index;
  }

  trackByVisualIndex(index: number): number {
    return index;
  }

  hasAdminVisuals(feature: ProductFeature): boolean {
    return !!feature.adminVisualBlocks?.length;
  }

  getScreenshotSlides(feature: ProductFeature): ProductScreenshotSlide[] {
    if (feature.adminVisualBlocks?.length) {
      return feature.adminVisualBlocks.map((block) => ({
        src: block.src,
        altKey: block.titleKey,
      }));
    }
    return [{ src: feature.screenshot, altKey: feature.screenshotAltKey }];
  }

  onScreenshotError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = 'assets/images/marketing/Mobile-Management.svg';
  }
}
